import type { ReactNode } from 'react';

type U2000KeyboardKeyHintProps = {
  children: ReactNode;
  /** Masque la pastille pour les lecteurs d'écran si le libellé parent est explicite. */
  ariaHidden?: boolean;
  className?: string;
};

/** Pastille visuelle pour un raccourci clavier (F8, F3, Entrée, Échap). */
const U2000KeyboardKeyHint: React.FC<U2000KeyboardKeyHintProps> = ({ children, ariaHidden = true, className = '' }) => (
  <kbd
    aria-hidden={ariaHidden ? true : undefined}
    className={`inline-flex min-h-4.5 items-center justify-center rounded-sm border border-gray-300 bg-gray-50 px-1.5 py-0.5 text-[10px] font-medium leading-none text-gray-600 shadow-xs ${className}`.trim()}
  >
    {children}
  </kbd>
);

export default U2000KeyboardKeyHint;
